<template>
  <div class="pageContent">

    <div>
        <img style="width:100%;" src="../../../static/user/wxBind.png" />  
    </div> 

    <div class="bigpage">


          <!--快捷登录-->
      <div>
        <div align="left" style="margin-top:2vh">
        <div style="text-align:right;margin-bottom:10px;display:none;">
          <mu-switch label="绑定已有账号" class="demo-switch" @change='switchChange'/>
          </div>
          <!--<mu-divider class="dividerClass"/>-->
          <mu-text-field hintText="请输入手机号" type="text" icon="smartphone" v-model="UserPhone" fullWidth="" style="margin-left:-4% ; width:103% " />
          <mu-text-field hintText="请输入密码" type="password" icon="lock" v-model="bindPwd" fullWidth="" style="margin-left:-4% ; width:103% " v-bind:style="{display:userRegister }"/>
          <nobr>
            <!--图片附加码-->
            <mu-text-field hintText="请输入附加码" type="text" icon="vpn_key" v-model="FJM1" class="txtValidate" style="margin-left:-4% ; width:69% " />
            <img v-bind:src="TPFJM" style="width:30% ;   float:right;   margin-top: -0.1rem" v-on:click="this.getValidateCode" />
          </nobr>

          <nobr>
            <mu-text-field hintText="请输入手机验证码" type="text" icon="verified_user" v-model="YZM" class="txtValidate" style="margin-left:-4% ; width:69% ; z-index: 1" />

            <span v-on:click="getYZM" v-show="haveYZM == false">
              <input type="button" value="获取" style="font-size:0.32rem ; float:right ; background-color:#27ba69 ; height: 0.7rem  ; border:none  ;  width: 30% ;  color:white" />
            </span>
            <span v-show="haveYZM == true">
              <input type="button" v-model="WaitTime" style="font-size:0.32rem ; float:right ;   background-color:#eeeeee ;   height: 0.7rem  ; border:none  ;  width: 30% ; color:#999 ;" />
            </span>
          </nobr>
        </div>

        <mu-raised-button label="马上绑定" primary="" @click="QuickLogin" v-bind:style="{ width:'100%', height:'0.8rem' }" style="font-size: 0.32rem ; margin-top:0.2rem " />
        <div style="margin-top:0.3rem;" v-bind:style="{display:userRegister }">
          <a style="color:#999999;" @click="forgetPwd">忘记密码？</a>
        </div>
      </div>






    </div>


    <!--下方通用  END-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>



<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'

export default {
  data() {

    return {
      activeTab: 'tab2',

      //  输入框初始化 1 
      UserName: '',
      UserPass: '',
      haorem: true,
      FJM1: '',

      FJMPD: false,

      //  输入框初始化  END

      //  附加码图片
      TPFJM: '',

      //  输入框初始化 2 
      UserPhone: '',
      YZM: '',
      //  输入框初始化  END  2 


      // 弹出层 弹出内容
      toast: false,
      TellUser: '',
      // 弹出层 弹出内容  END


      haveYZM: false,
      WaitTime: '',
      Time: 29,

      urls:'',
      code:"NULL",
      bindPwd:'',
      userRegister:'none',
      register:true,
      unionid:"NULL"

    }
  },
  //进入时运作
  activated() {
       if ( this.$route.query.usr!= undefined )
                {
                    this.UserPhone=this.$route.query.usr; //获取转入参数 手机号码
                }
    this.FJM1 = '';
    this.getValidateCode();

    //判断是否已经绑定过微信
    this.code=this.$route.query.code;
    this.unionid=this.$route.query.unionid;
    this.checkBind();

  },

  created(){
    this.getUnionLoginUrl()
  },

  // 数据获取
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_loginInfo'
    ])
  },
  methods: {
    ...mapMutations([
      'setG_UserInfo', 'setG_loginInfo'
    ]),

    checkBind(){


        if(this.code=="NULL"){
            window.alert('您已绑定过微信！');
            //window.location.href="https://i.998.com/wxOauth?redirect=https://i.998.com/user/UserCenter";
            window.location.href=api.getDomainURL()+"/wxOauth?redirect="+api.getDomainURL()+"/user/UserCenter";
        }else if(this.code=="ERROR"){
            window.alert("微信服务号授权出错,请重试！");
        } 
    },
    // 图片验证码
    getValidateCode() {
      this.TPFJM = api.getNumValidateCode();
    },
    // 常规登陆方式
    Login1() {
      this.UserName = this.UserName.trim();
      this.UserPass = this.UserPass.trim();
      this.FJM1 = this.FJM1.trim();

      if (this.UserName == '') {
        this.TellUser = '请输入用户名';
        this.showToast();
      }
      else if (this.UserPass == '') {
        this.TellUser = '请输入密码';
        this.showToast();
      }

      else {

        var params = new this.URLSearchParam();
        params.append('userName', this.UserName);
        params.append('password', this.UserPass);
        params.append('captcha', this.FJM1);

        this.$http.post(api.SignIn(), params.toParam()).then((res) => {
          console.log(res);

          if (res.Result == true) {

            // 保存登录信息 + 跳转
            this.SaveUserInfo(res.Data);
            var loginInfo = this.g_loginInfo
            loginInfo.Card_no = res.Data.Card_no
            this.setG_loginInfo(loginInfo)

            // 20171219把后跳加回来  不要，是因为， SaveUserInfo 这里面有后退。
            // this.goback()
          }
          else {  //登陆失败
            this.TellUser = res.Message;
            this.showToast();

            this.getValidateCode()

            //  三次密码错误后，提示需要输入验证码。显示验证码模块
            if (res.Message == "密码错误次数超出限制") {
              this.FJMPD = true;
            }

            if( this.TellUser == '需要强制改密'){
              this.TellUser = '您的账号存在安全隐患，请您立即重置密码。';
              setTimeout(() => { 

                this.$router.push({ path: '/user/ForgotPass' });

              }, 2200)
            }
          }
        })
      }

    },


    SaveUserInfo(result) {// 保存登录信息
      // 保存登录信息
      var UserInfo = result;

      if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
        UserInfo.Card_Kind_Diplay = '数字卡';
      }

      UserInfo.OrderRefresh1 = true;
      UserInfo.OrderRefresh2 = true;
      UserInfo.OrderRefresh3 = true;

      // 保存登录信息
      this.setG_UserInfo(UserInfo);

      this.UserName = '';
      this.UserPass = '';
      this.FJM1 = '';
      this.YZM = '';


      if (UserInfo.goUserCenter) {
        this.$router.push({ path: '/user/UserCenter' });
      }
      else {
        this.goback();
      }

    },


    // 常规登陆方式  END

    //  获取验证码
    getYZM() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号';
        this.showToast();
      }
      else if (this.FJM1 == '') {
        this.TellUser = '请输入附加码';
        this.showToast();
      }
      else {

        this.haveYZM = true;
        this.WaitTime = this.Time + "秒"
        this.timer();

        var params = new this.URLSearchParam();
        params.append('phoneNo', this.UserPhone);
        params.append('captcha', this.FJM1);

        this.$http.post(api.getSMSLoginCode(), params.toParam()).then((res) => {

          console.log(res)
          if (res.Result == true) {

            this.TellUser = res.Data;
            this.showToast();

          }
          else {  // 失败
            this.TellUser = res.Message;
            this.showToast();
            this.FJM1 = '';

            this.getValidateCode();

            this.Time = 5;
          }
        })
      }
    },
    timer() {
      if (this.Time > 0) {
        this.Time--;
        this.WaitTime = this.Time + "秒"

        setTimeout(this.timer, 1000);
      }
      else if (this.Time == 0) {
        this.haveYZM = false;
        this.Time = 29;
      }
    },
    //  获取验证码  END

    //  快捷登录
    QuickLogin() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号';
        this.showToast();
      }
      else if (this.Verification2 == '') {
        this.password = '请输入附加码';
        this.showToast();
      }
      else if (this.YZM == '') {
        this.TellUser = '请输入动态密码';
        this.showToast();
      }else if(this.bindPwd==''&&this.register==false){
        this.TellUser = '请输入密码';
        this.showToast(); 
      }
      else {
        var params = new this.URLSearchParam();
        params.append('phoneNo', this.UserPhone);
        params.append('captcha', this.FJM1);
        params.append('validateCode', this.YZM);
        params.append('code', this.code); //openid
        params.append('bindPwd', this.bindPwd);
        params.append('register', this.register);
        params.append('unionid', this.unionid);
        //  快捷登录 
        this.$http.post(api.WXBindLogin(), params.toParam()).then((res) => {
          if (res.Result == true) {

            var result = res.Data;
            // 保存登录信息
            this.SaveUserInfo(result);
            var loginInfo = this.g_loginInfo
            loginInfo.Card_no = res.Data.Card_no
            this.setG_loginInfo(loginInfo)
            window.alert("绑定成功！");
            window.location.href=api.getDomainURL()+'/user/UserCenter';
            //this.goback()
          }
          else {  //登陆失败
            this.TellUser = res.Message;
            this.showToast();
          }
        })
      }
    },
    //  快捷登录  END







    handleTabChange(val) {
      this.activeTab = val
    },

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 2500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    // 弹出标签 选择是否
    open() {
      this.dialog = true
    },
    closeYES() {
      this.dialog = false;
      //调用弹出层
      this.showToast();
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否


    // 后退一页
    goback() {
      javascript: history.go(-1);
      //this.$router.go(-1)
      //console.log('i come')
    },

    getUnionLoginUrl(){
      this.$http.post(api.getUnionLoginUrl()).then((res) => {
        this.urls = res.Data
        console.log(this.urls)
      })
    },
    forgetPwd(){
      this.$router.push({ path: '/wxBind/forgetPass' });
    },
    switchChange(){
      if(this.userRegister=='none'){
        this.userRegister='block';
        this.register=false;
        this.UserPhone='';
        this.bindPwd='';
        this.FJM1='';
        this.getValidateCode();
        this.YZM='';

      }else{
        this.userRegister='none';
        this.register=true;
         this.UserPhone='';
         this.FJM1='';
        this.getValidateCode();
        this.YZM='';
      }
    }

  }
}

</script>


<style lang="less" >
@import "../../assets/theme.less"; // 顶部标签变换
.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
.pageContent {
  max-width: 480px; // margin-left: auto;
  // margin-right: auto;
  // text-align: center;
  .bigpage {
    width: 80%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor ;
  }

  .Black {
    color: @primaryBlack ;
  }

  .Grey {
    color: @textColor ;
  } // .txtValidate {
  //   .mu-text-field-content {
  //     .mu-text-field-hint {
  //       width: 120px;
  //      border:1px dashed #000; 
  //     }
  //   }
  // }
  .mu-tabs {
    background-color: #fff;
    .mu-tab-link {
      color: @greyFontColor;
    }
    .mu-tab-active {
      color: @primaryColor;
    }
    .mu-text-field-line {
      background-color: #FFF;
    }
  }
}
.unionLogin{
  margin-bottom: 56px;
  clear:both;
  .top{
    color:#999999;
    font-size:0.3rem;
    display:flex;
    justify-content:center;
    margin:2rem 0.6rem 0 0.6rem;
    .line{
      border-top:1px solid #cccccc;
      height:0px;
      margin:auto 0.1rem;
      flex-grow:1;
    }
  }
  .btns{
    margin-top:0.52rem;
    display:flex;
    justify-content:center;
    img{
      width:0.8rem;
      height:0.8rem;
    }
    .center{
      margin:0 0.5rem;
    }
  }
}
</style>






// WEBPACK FOOTER //
// checkWXBindResult.vue?be63cd52